import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Order } from '@/types';
import OrderCard from './OrderCard';

interface OrdersListProps {
  orders: Order[];
  activeOrderId: string | null;
  onSelectOrder: (orderId: string) => void;
  onCreateOrder: () => void;
  onUpdateQuantity: (orderId: string, itemId: string, quantity: number) => void;
  onAddItems: (orderId: string) => void;
  onSendToKitchen: (orderId: string) => void;
  onPrintOrder: (orderId: string) => void;
  onCancelItem: (orderId: string, itemId: string) => void;
  isCreatingOrder: boolean;
}

const OrdersList: React.FC<OrdersListProps> = ({
  orders,
  activeOrderId,
  onSelectOrder,
  onCreateOrder,
  onUpdateQuantity,
  onAddItems,
  onSendToKitchen,
  onPrintOrder,
  onCancelItem,
  isCreatingOrder,
}) => {
  const openOrders = orders.filter(order => order.status === 'open');
  const closedOrders = orders.filter(order => order.status === 'paid');

  return (
    <div className="space-y-6">
      {/* Pedidos Abertos */}
      <div>
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-foreground">
            Pedidos Abertos ({openOrders.length})
          </h2>

          <Button
            onClick={onCreateOrder}
            disabled={isCreatingOrder}
            className="flex items-center gap-2"
          >
            <Plus className="h-4 w-4" />
            {isCreatingOrder ? 'Criando...' : 'Novo Pedido'}
          </Button>
        </div>
        
        <div className="space-y-4">
          {openOrders.length > 0 ? (
            openOrders.map((order) => (
              <OrderCard
                key={order.id}
                order={order}
                isSelected={order.id === activeOrderId}
                onClick={() => onSelectOrder(order.id)}
                onUpdateQuantity={(itemId, quantity) => onUpdateQuantity(order.id, itemId, quantity)}
                onAddItems={() => onAddItems(order.id)}
                onSendToKitchen={() => onSendToKitchen(order.id)}
                onPrintOrder={() => onPrintOrder(order.id)}
                onCancelItem={(itemId) => onCancelItem(order.id, itemId)}
              />
            ))
          ) : (
            <Card>
              <CardContent className="text-center py-8">
                <p className="text-muted-foreground">
                  Nenhum pedido aberto para esta mesa
                </p>
              </CardContent>
            </Card>
          )}
        </div>
      </div>

      {/* Pedidos Fechados/Pagos */}
      {closedOrders.length > 0 && (
        <div>
          <h2 className="text-xl font-semibold text-foreground mb-4">
            Pedidos Finalizados ({closedOrders.length})
          </h2>
          
          <div className="space-y-4">
            {closedOrders.map((order) => (
              <OrderCard
                key={order.id}
                order={order}
                onUpdateQuantity={() => {}} // Pedidos fechados não podem ser editados
                onAddItems={() => {}}
                onSendToKitchen={() => {}}
                onPrintOrder={() => onPrintOrder(order.id)}
                onCancelItem={() => {}}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default OrdersList;